export * from './delete-bereich.service';
export * from './delete-bereich.service.module';